import { Link, useNavigate } from "react-router-dom";
import "./Home-Comp.css";
import { IAuthType } from "../../apiservice/authService.type";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import { useEffect } from "react";

export const StartScreenComp = () => {
  const navigate = useNavigate();
  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  useEffect(() => {
    navigate("/auth");
  }, [authData, navigate]); // Added authData and navigate as dependencies

  return (
    <>
      {/* {process.env.PUBLIC_URL} */}

      <div className="flex-col w-full min-h-screen h-full bg-white dark:bg-stone-900">
        <div className="flex flex-col h-full">
          <div className="flex justify-left mt-8 p-4">
            <img
              className="w-48 rounded-xl"
              alt="_img"
              src={`${process.env.PUBLIC_URL + "/images/logoblue.svg"}`}
            />
          </div>
          {/* <div className="flex justify-center mt-12">
            <img
              className="rounded-xl h-[200px]"
              alt="_img"
              src={`${process.env.PUBLIC_URL + "/images/welcomePicture.svg"}`}
            />
          </div> */}
        </div>

        <div className="flex items-center justify-center w-full h-full">
          <div className="mt-10 w-full flex flex-col items-center">
            <h2 className=" font-bold text-blue-800 dark:text-blue-400 text-3xl">
              {" "}
              Welcome{" "}
            </h2>
            <p className="text-lg mt-2"></p> {/* This p tag is empty */}
          </div>
        </div>
        <div className="flex items-center justify-center w-full h-full">
          <div className="mt-10 w-full flex flex-col items-center">
            <Link className="w-3/4" to={"/auth"}>
              <button className="mb-4 w-full py-2 text-white bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 rounded-tl-2xl rounded-br-2xl h-12">
                Login
              </button>
            </Link>
            <Link className="w-3/4" to={"/auth/signup"}>
              <button className="mb-4 w-full py-2 text-blue-800 bg-white border-blue-800 border hover:bg-gray-100 dark:text-blue-400 dark:bg-stone-800 dark:border-blue-400 dark:hover:bg-stone-700 rounded-tl-2xl rounded-br-2xl h-12">
                {"Sign Up"}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default StartScreenComp;
